import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
var WCList = {
  pn: 'div[data-name="warning-customer"]',
  page: 0,
  limit: 50,
  currentDisplay: 0,
  allowInfinite: true,
  hasMoreItems: true,
  totalItems: 0,
  init: function init() {
    var self = this;
    self.page = 0;
    self.currentDisplay = 0;
    self.allowInfinite = true;
    self.hasMoreItems = true;
    self.list();
    $(self.pn + ' .infinite-scroll-content').on('infinite', function () {
      if (!self.allowInfinite) return;
      self.allowInfinite = false;
      self.page += 1;
      self.list();
    });
  },
  appendRow: function appendRow(item) {
    var checked_label = '<i class="f7-icons icon">bookmark_fill</i>';
    var checked_at = item.checked_at === null ? '<a class="checked_at"><i class="f7-icons icon">bookmark</i></a>' : checked_label;
    var viewed_at = item.viewed_at === null ? '' : moment(item.viewed_at).format(Base.dateTimeFormat);
    var $row = $("\n      <tr>\n        <td>".concat(item.ma_khachhang, "</td>\n        <td class=\"text-align-center\">").concat(checked_at, "</td>\n        <td class=\"gray-smaller text-align-right\">").concat(viewed_at, "</td>\n      </tr>  \n    "));
    $row.data('row', item);
    $row.find('.checked_at').click(function (e) {
      Base.app.dialog.confirm('Đã kiểm tra khách này?', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loader;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loader = Base.app.dialog.preloader();
                _context.next = 3;
                return Base.api('WarningCustomer', 'checked_at', {
                  id: item.id
                });

              case 3:
                $(e.target).closest('td').html(checked_label);
                loader.close();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    });
    return $row;
  },
  list: function () {
    var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var self, rs;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              self = this;
              _context2.next = 3;
              return Base.api('WarningCustomer', 'paging', {
                page: self.page,
                limit: self.limit
              });

            case 3:
              rs = _context2.sent;
              self.totalItems = rs.total;

              if (!(rs.rows.length == 0)) {
                _context2.next = 8;
                break;
              }

              $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');
              return _context2.abrupt("return");

            case 8:
              self.currentDisplay += rs.rows.length;
              self.allowInfinite = true;
              rs.rows.forEach(function (item, i) {
                $(self.pn + ' .warning-customer-list tbody').append(self.appendRow(item));
              });
              if (self.currentDisplay == self.totalItems || self.currentDisplay > self.totalItems) $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');else $(self.pn + ' .infinite-scroll-preloader').removeClass('display-none');

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }()
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    WCList.init();
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="warning-customer">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
        <div class="title sliding">Khách hàng có nghi vấn </div>
      </div>
    </div>
    <div class="page-content infinite-scroll-content infinite-scroll-bottom">
      
      <div class="data-table card">
        <table class="warning-customer-list">
          <thead>
            <tr>
              <th>Khách hàng</th>
              <th>Đã kiểm tra</th>
              <th class="text-align-right">Đã xem</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>

      <div class="preloader infinite-scroll-preloader"></div>
    </div>
  </div>
`
    }
    ;
});